import Typography from '@platform-ui-common/components/Typography/index.js';
import PasswordValidationCondition from './PasswordValidationCondition.js';

interface PasswordValidationProps {
  password: string;
  errors: string[];
}

export default function PasswordValidation({
  password,
  errors,
}: PasswordValidationProps): JSX.Element {
  return (
    <div className="pt-2">
      <Typography variant="body">Password requirements:</Typography>
      <div className="py-3 flex flex-col gap-y-3">
        <PasswordValidationCondition
          label="At least 12 characters long"
          valid={password && !errors?.includes('min')}
          testId="pvc-12-char"
        />
        <PasswordValidationCondition
          label="Includes a special character (for example, !@#$%)"
          valid={password && !errors?.includes('symbols')}
          testId="pvc-contains-punct"
        />
        <PasswordValidationCondition
          label="Includes at least one number (for example, 0123456789)"
          valid={password && !errors?.includes('digits')}
          testId="pvc-contains-num"
        />
      </div>
    </div>
  );
}
